/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentAcademicRecordTitle model module.
 * @module model/StudentAcademicRecordTitle
 * @version 1.0
 */
class StudentAcademicRecordTitle {
    /**
     * Constructs a new <code>StudentAcademicRecordTitle</code>.
     * @alias module:model/StudentAcademicRecordTitle
     */
    constructor() { 
        
        StudentAcademicRecordTitle.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentAcademicRecordTitle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentAcademicRecordTitle} obj Optional instance to populate.
     * @return {module:model/StudentAcademicRecordTitle} The populated <code>StudentAcademicRecordTitle</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentAcademicRecordTitle();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('student_id')) {
                obj['student_id'] = ApiClient.convertToType(data['student_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program_translation')) {
                obj['academic_program_translation'] = ApiClient.convertToType(data['academic_program_translation'], 'String');
            }
            if (data.hasOwnProperty('status_id')) {
                obj['status_id'] = ApiClient.convertToType(data['status_id'], 'Number');
            }
            if (data.hasOwnProperty('comments')) {
                obj['comments'] = ApiClient.convertToType(data['comments'], 'String');
            }
            if (data.hasOwnProperty('created_by')) {
                obj['created_by'] = ApiClient.convertToType(data['created_by'], 'Number');
            }
            if (data.hasOwnProperty('updated_by')) {
                obj['updated_by'] = ApiClient.convertToType(data['updated_by'], 'Number');
            }
            if (data.hasOwnProperty('deleted_by')) {
                obj['deleted_by'] = ApiClient.convertToType(data['deleted_by'], 'Number');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'String');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'String');
            }
            if (data.hasOwnProperty('deleted_at')) {
                obj['deleted_at'] = ApiClient.convertToType(data['deleted_at'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
StudentAcademicRecordTitle.prototype['id'] = undefined;

/**
 * @member {Number} student_id
 */
StudentAcademicRecordTitle.prototype['student_id'] = undefined;

/**
 * @member {Number} academic_program_id
 */
StudentAcademicRecordTitle.prototype['academic_program_id'] = undefined;

/**
 * @member {String} academic_program_translation
 */
StudentAcademicRecordTitle.prototype['academic_program_translation'] = undefined;

/**
 * @member {Number} status_id
 */
StudentAcademicRecordTitle.prototype['status_id'] = undefined;

/**
 * @member {String} comments
 */
StudentAcademicRecordTitle.prototype['comments'] = undefined;

/**
 * @member {Number} created_by
 */
StudentAcademicRecordTitle.prototype['created_by'] = undefined;

/**
 * @member {Number} updated_by
 */
StudentAcademicRecordTitle.prototype['updated_by'] = undefined;

/**
 * @member {Number} deleted_by
 */
StudentAcademicRecordTitle.prototype['deleted_by'] = undefined;

/**
 * @member {String} created_at
 */
StudentAcademicRecordTitle.prototype['created_at'] = undefined;

/**
 * @member {String} updated_at
 */
StudentAcademicRecordTitle.prototype['updated_at'] = undefined;

/**
 * @member {String} deleted_at
 */
StudentAcademicRecordTitle.prototype['deleted_at'] = undefined;






export default StudentAcademicRecordTitle;

